import React from 'react';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import AppointmentSlotsTable from './AppointmentSlotsTable';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useGetAllTerminSlots } from '../../../../api/termins';
import LanguageSelect from '../../../selectTranslation/translateSelect';

const AppointmentsSlots = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, isLoading, isFetching } = useGetAllTerminSlots();
  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }} minHeight="100vh">
      <Box display="flex" flexDirection="column" width="100%">
        <Box display="flex" justifyContent="space-between" alignItems="center" px={4}>
          <IconButton onClick={() => navigate(-1)} sx={{ marginLeft: -2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" fontWeight={700} px={5} py={2.45} sx={{ marginLeft: -4, flexGrow: 1 }}>
            {t('AppointmentSlots')}
          </Typography>
          <LanguageSelect />
        </Box>
        <Divider />
        <Box p={5}>
          <Box display="flex" flexDirection="column">
            <AppointmentSlotsTable slots={data} isLoadingSlots={isLoading || isFetching} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AppointmentsSlots;
